<template lang="pug">
  .component-invoice-controller
    .row
      .columns.large-5
        driver(v-if="client", :type="'driver-card'", :item="client.main_driver")
      .columns.shrink
        span Emission Date
        h4(v-if="item.emission_date") {{$dateFormat(item.emission_date,'DD/MM/YYYY')}}
        span Overdue Date
        h4(v-if="item.due_date") {{$dateFormat(item.due_date,'DD/MM/YYYY')}}
      .columns.shrink
        span Status
        h4 {{item.status}}
        template(v-if="$isModuleEnabled('aruba-italian-e-invoice')")
          span Xml filename
          h4(v-if="item.extra.hasOwnProperty('einvoice')") {{item.extra.einvoice.uploadedFileName}}
          h4(v-else) --

      .column
        span Document type
        h4 {{item.type}}
        span Number
        h4(v-if="item.type !== 'PROFORMA'" ) {{item.internal_id}}
        h4(v-else) --

    .row
      .columns
        .card
          .inner-content
            .row
              .columns
                client(:item="client", :type="'billing'")
              .columns
                client(:item="client", :type="'contacts'")
            .row
              .columns
                table
                  thead
                    tr
                      th Id
                      th Driver Id
                      th Type & Id
                      th Description (Reason)
                      th.text-center Tax
                      th.text-center Amount
                  tbody
                    tr(v-for="item in item.records")
                      td {{item.id}}
                      td {{item.driver_id}}
                      td
                        div {{item.walletable_type | walletableType}}
                        div {{item.walletable_id}}
                      td(style="font-family: monospace;")
                        div(v-for="reason in item.reason.split('|')")
                          hr(v-if="reason.startsWith('---')", style="border-style: dotted; margin:0.5em")
                          strong(v-else-if="reason.startsWith('- ')") {{cleanString(reason,"- ")}}
                          span(v-else-if="reason.startsWith('>>')", style="display: block; text-indent: 1em;") {{cleanString(reason,">>")}}
                          span(v-else) {{reason}}
                      //td(v-html="explodeReason(item.reason)")
                      td.text-center
                        div {{currency}}{{parseFloat(item.amount * item.tax).toFixed(2)}}
                        div
                          small {{-item.tax*100}}%
                      td.text-center
                        div {{$priceWithcurrency($priceWithVat(-item.amount, -item.tax).toFixed(2))}}
                        div
                            small {{$priceWithcurrency(-item.amount)}} VAT EXC

            .row
              .columns.shrink.large-offset-9
                p Subtotal
              .columns.text-right
                h2 {{$priceWithcurrency(item.subtotal)}}
            .row
              .columns.shrink.large-offset-9

                p Tax total
              .columns.text-right
                h2 {{$priceWithcurrency(item.tax)}}
            .row
              .columns.shrink.large-offset-9
                p Total
              .columns.text-right
                h2 {{currency}}{{item.document_total}}
            .row(v-if="item.deposits.length")
              .columns.shrink.large-offset-9
                p Paid deposits
              .columns.text-right
                h2 -{{$priceWithcurrency(depositsPaid)}}
            .row
              .columns.shrink.large-offset-9
                p Net to pay
              .columns.text-right
                h2 {{$priceWithcurrency(item.total)}}
            .row(v-if="item.deposits.length")
              .columns
                h2 Deposit details:
                Deposit(v-for="deposit in item.deposits", :item="deposit", type="listing")

            .row(v-if="$isModuleEnabled('aruba-italian-e-invoice')")
              .column
                h2 Stati fatturazione elettronica
                .container(v-if="item.extra.hasOwnProperty('einvoice')")
                  base-list(:component="component", :dataLoader="xmlStatus", componentType="einvoice")


</template>
<script type="text/babel">
import Client from 'components/backoffice/Client'
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import Invoice from '../../../components/backoffice/Invoice.vue'
import {mapState} from 'vuex'
import collect from 'collect.js'
import Deposit from '../../../components/backoffice/Deposit'
import CardN from '../../../components/structure/CardN'
import BaseList from '../BaseList'
import Driver from 'components/backoffice/Driver'

export default {
  name: 'InvoiceController',
  components: {
    BaseList,
    CardN,
    Deposit,
    Invoice,
    Client,
    Driver,
  },
  data() {
    return {
      client: null,
      component: require('src/components/backoffice/Invoice'),
    }
  },
  created() {
    KeplerBackofficeSdk.clients.select(this.item.billing_info.client_id).get((item) => {
      this.client = item
    })
  },
  methods: {
    explodeReason(reason) {
      return reason.replace(/\|/g, '<br>')
    },
    xmlName(n) {
      var chars = '0123456789abcdefghijklmnopqrstuvwxyz'
      var base = chars.length
      var converted = ''
      while (n > 0) {
        converted = chars.substr((n % base), 1) + converted
        n = Math.floor(n / base)
      }
      var codiceIva = this.configuration['italian-e-invoice']['italian-e-invoice_codice-iva']['value']
      var paeseIva = this.configuration['italian-e-invoice']['italian-e-invoice_paese-iva']['value']
      var progressivo = this.configuration['italian-e-invoice']['italian-e-invoice_prefisso_progressivo_univoco']['value']
      return `${paeseIva}${codiceIva}_${progressivo ? progressivo : ''}${converted}.xml`
    },
    xmlStatus(callback) {
      callback({
        current_page: 1,
        current_page_count: 1,
        items: this.item.extra.einvoice.results.reverse(),
        items_count: this.item.extra.einvoice.results.length,
        page_count: 1,
        per_page_count: this.item.extra.einvoice.results.length,
      })
    },
    cleanString(string, char) {
      const r = new RegExp(`${char}`, 'gi');
      return string.replace(r, "")
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    currency() {
      return this.configuration.commercial.commercial_currency.value
    },
    depositsPaid() {
      return collect(this.item.deposits).sum('amount')
    },
  },
  filters: {
    walletableType(value) {
      return value.replace(/App\\Models\\/, '')
    }
  },
  props: ['item'],

}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Invoice.vue?081605cb